import React from "react";
import { Chip } from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import StorefrontIcon from "@mui/icons-material/Storefront";
import SellIcon from "@mui/icons-material/Sell";
import type { ItemStatus } from "../services/api";

const statusConfig: Record<
  ItemStatus,
  { label: string; color: "info" | "secondary" | "warning" | "success"; icon: React.ReactElement }
> = {
  purchased: {
    label: "Purchased",
    color: "info",
    icon: <ShoppingCartIcon fontSize="small" />,
  },
  priced: {
    label: "Priced",
    color: "secondary",
    icon: <LocalOfferIcon fontSize="small" />,
  },
  in_booth: {
    label: "In Booth",
    color: "warning",
    icon: <StorefrontIcon fontSize="small" />,
  },
  sold: {
    label: "Sold",
    color: "success",
    icon: <SellIcon fontSize="small" />,
  },
};

interface StatusChipProps {
  status: ItemStatus;
  size?: "small" | "medium";
}

export default function StatusChip({ status, size = "small" }: StatusChipProps) {
  const config = statusConfig[status];
  return (
    <Chip
      icon={config.icon}
      label={config.label}
      color={config.color}
      size={size}
      variant="filled"
    />
  );
}
